export * from './filter-by.pipe';
export * from './limit-to.pipe';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/pipes/index.ts